module.exports = __webpack_public_path__ + "img/map.41920528.png";